import { BREADCRUMB_QUERY_PARAM } from '@/components/Breadcrumb/hooks/useBreadcrumb';

export function getNavigationQuery(breadcrumbUrl: string[] | null | undefined) {
  if (!breadcrumbUrl) return { parentEntityId: '' };
  const updatedBl = breadcrumbUrl?.length ? breadcrumbUrl.slice(0, -1) : [];
  const query = {
    [BREADCRUMB_QUERY_PARAM]: updatedBl,
    parentEntityId: '',
  };
  if (updatedBl.length) {
    query.parentEntityId = updatedBl.at(-1) ?? '';
  }
  return query;
}
